export default __webpack_public_path__ + "static/media/analisis_de_datos_adn.7d1c0e0b.png";